import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/public/build-scalable.png");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/public/design-robust.svg");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/public/image 28 (1).png");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/public/impelement-security.svg");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/public/lpa-full-logo.png");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/public/lpa-grey.png");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/public/optimize-cloud.png");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/public/Rectangle 22.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/app/[lang]/blog/[slug]/SidebarSearchCard.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/app/[lang]/browsecourses/[type]/[slug]/Enquiry.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/BlogCarousel.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/BlogNewsletterStrip.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/molecules/index.jsx");
